import Vue from 'vue';
import { Module } from 'vuex';

import { LearningGroup, RootState } from 'frontend/types';

import { postData } from 'frontend/utils/ajax';

interface LearningGroupsState {
  items: LearningGroup[];
}

interface NotifyComingSoonParams {
  courseId: number;
  notifyWhenPublished: boolean;
}

const learningGroups: Module<LearningGroupsState, RootState> = {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {},
  mutations: {
    setValue(state: LearningGroupsState, value: LearningGroup[]): void {
      Vue.set(state, 'items', value);
    },
    setNotifyComingSoon(state: LearningGroupsState, params: NotifyComingSoonParams) {
      state.items.forEach(group => {
        group.courses = group.courses.slice().map(course => {
          if (params.courseId === course.course_id) {
            course.notify_when_published = params.notifyWhenPublished;
          }
          return course;
        });
      });
    },
  },
  actions: {
    notifyComingSoon({ commit }, course): Promise<any> {
      const url = `/api/v1/quizzes/coming_soon_notification/exploration/${course.slug}/`;
      const data: { unset_notification?: boolean } = {};
      if (course.notify_when_published) {
        data.unset_notification = true;
      }
      return postData(url, data).then((response: any) => {
        if (response.success) {
          const params: NotifyComingSoonParams = {
            courseId: course.course_id,
            notifyWhenPublished: response.data.notify_when_published,
          };
          commit('setNotifyComingSoon', params);
        }
      });
    },
  },
};

export default learningGroups;
